import {Spinner} from '@blueprintjs/core';
import {CSSProperties, ReactNode, useEffect, useMemo, useState} from 'react';

export type PendingRenderFn<T> = (resource: T) => ReactNode;

interface Props<T> {
	resource: Promise<T>,
	children: PendingRenderFn<T>,
	size?: number,
	inline?: boolean,
}

export default function Pending<T>({size, inline, children, resource}: Props<T>): ReactNode {
	const [content, setContent] = useState<T | undefined>(undefined);

	useEffect(() => {
		resource.then(setContent);

		return () => {
			setContent(undefined);
		};
	}, [resource]);

	const spinnerStyle: CSSProperties = useMemo(() => {
		return {marginTop: inline ? 5 : 50};
	}, [inline]);

	if (content === undefined)
		return <Spinner intent="primary" size={size} style={spinnerStyle} />;

	return children(content);
}
